<template>
  <md-card style="z-index: 0">
    <md-card-content class="body-card-benefits">
      <h3>Benefits</h3>

      <md-button
        class="md-primary add-benefit"
        @click.native="addBenefit"
      >
        Add Benefit
      </md-button>

      <md-progress-bar
        v-if="loading"
        md-mode="indeterminate"
      />

      <md-card
        v-for="(b, index) in benefits"
        v-else
        :key="b.uiId"
        class="benefit-card"
      >
        <md-card-content>
          <div class="benefits-top-line">
            <div class="title-wrapper">
              <language-key-form
                title="title"
                :values="b.title"
                @update="(v) => onTitleChange(index, v)"
              />
            </div>
            <div class="buttons-wrapper">
              <md-button
                class="md-icon-button"
                style="padding: 5px 0 5px 0; background-color: #ff1745 !important; margin-top: 0;"
                @click.native="showDeleteDialog(index)"
              >
                <md-icon>delete</md-icon>
              </md-button>

              <md-button
                class="md-icon-button"
                style="padding: 5px 0 5px 0;"
                @click.native="copyBenefit(index)"
              >
                <md-icon>content_copy</md-icon>
              </md-button>
            </div>
          </div>

          <div class="benefits-bottom-line">
            <div class="field-line">
              <img :src="b.imageUrl">
              <md-field>
                <label>Image URL</label>
                <md-input v-model="b.imageUrl" />
              </md-field>
            </div>

            <md-field style="width: 50%; margin: 0 0 0 8px">
              <label>Platform</label>
              <md-select v-model="b.platform">
                <md-option value="all">
                  All
                </md-option>
                <md-option value="iOS">
                  iOS
                </md-option>
                <md-option value="macos">
                  macOS
                </md-option>
                <md-option value="android">
                  Android
                </md-option>
                <md-option value="windows">
                  Windows
                </md-option>
                <md-option value="web">
                  Web
                </md-option>
              </md-select>
            </md-field>
          </div>
        </md-card-content>
      </md-card>
    </md-card-content>

    <md-dialog-confirm
      :md-active.sync="isDeleteDialogActive"
      md-title="Delete this benefit?"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-cancel="isDeleteDialogActive = false"
      @md-confirm="deleteBenefit"
    />
  </md-card>
</template>
<script>
    import { uiId } from "@/utils/uiId";
    import LanguageKeyForm from "@/components/Forms/LanguageKeyForm";

    export default {
        components: {LanguageKeyForm },
        props: {
          benefits: { type: Array, default() { return []; } },
          loading: Boolean
        },
        data() {
            return {
                isDeleteDialogActive: false,
                benefitToDelete: ""
            };
        },
        methods: {
            onTitleChange(index, newValue) {
                this.benefits[index].title = newValue;
            },
            addBenefit() {
                this.benefits.push({
                    id: "",
                    title: { "en": "" },
                    imageUrl: "",
                    platform: "all",
                    uiId: uiId()
                });
            },
            copyBenefit(index) {
                const newBenefit = JSON.parse(JSON.stringify(this.benefits[index]));
                newBenefit.uiId = uiId();
                this.benefits.splice(index, 0, newBenefit);
            },
            showDeleteDialog(index) {
                this.isDeleteDialogActive = true;
                this.benefitToDelete = index;
            },
            deleteBenefit() {
                this.benefits.splice(this.benefitToDelete, 1);
                this.isDeleteDialogActive = false;
            }
        }
    };
</script>
<style lang="scss">
    .body-card-benefits {
        h3 {
            position: absolute;
            margin: 0;
        }

        button.add-benefit {
            position: sticky;
            top: 5px;
            left: 95%;
            margin: 0;
            z-index: 100;
        }
    }

    .benefit-card {
        margin: 10px 0 !important;

        .md-card-content {
            padding-bottom: 5px;
        }
    }

    .benefits-top-line {
        display: flex;
        justify-content: space-between;
        flex-direction: row;

        .title-wrapper {
            width: calc(100% - 50px);
        }
        .buttons-wrapper {
            min-width: 40px;
            width: 40px;
            margin-left: 10px;
        }
    }

    .benefits-bottom-line {
        display: flex;
        .field-line {
            display: flex;

            img {
                margin: auto 15px auto 0;
                width: 25px !important;
                height: 25px !important;
            }

            div.md-field {
                margin: 0;
                overflow-x: hidden;
            }
        }
    }

    @media only screen and (max-width: 850px) {
        .benefits-top-line {
            display: flex;
            justify-content: space-between;
            flex-direction: column-reverse;

            .buttons-wrapper {
                width: 100%;
                margin: 0 0 5px 0;
                button {
                    margin: 0;
                }
                button ~ button {
                    float: right;
                }
            }
            .title-wrapper {
                width: 100%;
            }
        }

        .benefits-bottom-line {
            flex-direction: column;
            margin-top: 0;

            div {
                width: 100% !important;
            }
        }
    }
    @-webkit-media only screen and (max-width: 850px) {
        .benefits-top-line {
            display: flex;
            justify-content: space-between;
            flex-direction: column-reverse;

            .buttons-wrapper {
                width: 100%;
                margin: 0 0 5px 0;
                button {
                    margin: 0;
                }
                button ~ button {
                    float: right;
                }
            }
            .title-wrapper {
                width: 100%;
            }
        }

        .benefits-bottom-line {
            flex-direction: column;
            margin-top: 0;

            div {
                width: 100% !important;
            }
        }
    }
</style>
